module.exports = __webpack_public_path__ + "img/section-01.86efca9c.webp";